import axios from '@/js/lib/axios';
import { updateToken } from './update_token';

export const send = async (email: string): Promise<{ error: boolean; message: string }> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('token', token);
  params.append('email', email);
  const res = await axios.post('/newsletter/subscribe', params);
  return res.data;
};

export const validateEmail = async (email: string): Promise<true | string> => {
  const res = await axios.get('/newsletter/validate-email', {
    params: {
      param_name: 'newsletter[email]',
      'newsletter[email]': email,
    },
  });
  return res.data;
};
